import _ErrorBoundary from './ErrorBoundary'

export const ErrorBoundary = _ErrorBoundary
